let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dxGZN")).then(() => parcelRequire('iOY2m'));